export class CustomerRequest {
    customerId: string;
    noIdentification: string;
    isClient: boolean;
    firstName: string;
    lastName: string;
    phone: string;
    homeNumber: string;
    email: string;
    estadoCivil: string;
    sexo: string;
    IdentificationType: string;
    constructor(
      customerId: string,
      noIdentification: string,
      isClient: boolean,
      firstName: string,
      lastName: string,
      phone: string,
      homeNumber: string,
      email: string,
      estadoCivil: string,
      sexo: string,
      IdentificationType?: string // Esta parte es utilizada
    ) {
      this.customerId = customerId;
      this.noIdentification = noIdentification.replace(/-/g, '');
      this.isClient = isClient;
      this.firstName = firstName;
      this.lastName = lastName;
      this.phone = phone?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      this.homeNumber = homeNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      this.email = email;
      this.estadoCivil = estadoCivil;
      this.sexo = sexo;
      this.IdentificationType = "cedula";
    }
  }
  
  export class SalesOpportunityRequest {
    productsType: string[];
    customer: CustomerRequest;
  
    constructor(productsType: string[], customer: CustomerRequest) {
      this.productsType = productsType;
      this.customer = customer;
    }
  }
  